import React, { useState, useEffect } from "react";
import Barcode from "react-barcode";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { AES, enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import "./ItemDetails.css";
import ItemUpdate from "./ItemUpdate";
import { CiEdit } from "react-icons/ci";
import { 
  FiBox, 
  FiPackage, 
  FiDollarSign, 
  FiShoppingCart,
  FiSearch 
} from "react-icons/fi";

function ItemDetails(props) {
  const handleCancleClick = () => {
    const confirmCancel = window.confirm("Are you sure Leave this page?");
    if (confirmCancel) {
      props.handleCancle();
    } else {
      console.log("Cancellation not confirmed");
    }
  };

  const { Itemid } = props;
  const [itemId1, setItemId1] = useState(Itemid);
  const [selectedTab, setSelectedTab] = useState("overview");
  const [searchTerm, setSearchTerm] = useState("");

  const [quantity, setQuantity] = useState("");
  const [barcodes, setBarcodes] = useState([]);
  const [showDetails, setShowDetails] = useState(true);
  const [showEditPage, setEditPage] = useState(false);
  const [editId, setEditId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const jwtToken = localStorage.getItem("jwtToken");
  const userId = localStorage.getItem("userId");

  const apiUrl = BASE_URL + `/fetchUserProfile`;
  const fetchData = () => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, userId: userId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const portfolioItem = data.responseMessage;
          setCompanyName(portfolioItem.companyName);
        } else {
          console.error("Error fetching portfolio data");
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditOpen = (id) => {
    setEditId(id);
    setEditPage(true);
    setShowDetails(false);
  };

  const handleCancel = () => {
    setEditPage(false);
    setShowDetails(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const parsedQuantity = parseInt(quantity, 10);
    if (isNaN(parsedQuantity) || parsedQuantity <= 0) {
      alert("Please enter a valid positive number for quantity");
      return;
    }

    const generatedBarcodes = Array.from(
      { length: parsedQuantity },
      (_, index) => itemId1
    );
    setBarcodes(generatedBarcodes);
  };

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
    setQuantity("");
    setBarcodes([]);
  };

  const [barCodeName, setBarCodeName] = useState();
  const [barCodeSalesPrice, setBarCodeSalesPrice] = useState();
  const [itemData, setItemData] = useState({});
  const [itemData1, setItemData1] = useState([]);

  // Overview
  useEffect(() => {
    const apiUrl = BASE_URL + `/getItemData/${itemId1}`;
    fetch(apiUrl, {
      method: "Post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(),
    })
      .then((response) => response.json())
      .then((data) => {
        setItemData(data.data);
      })
      .catch((error) => console.error("Error fetching overview data:", error));
  }, [itemId1]);

  // leftbar
  useEffect(() => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);
    const postApiUrl = BASE_URL + `/getAllItemData`;
    fetch(postApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, vendorId: "" }),
    })
      .then((response) => response.json())
      .then((data) => {
        setItemData1(data.responseMessage);
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  }, []);

  const handleItemChange = (id) => {
    setItemId1(id);
    setSelectedTab("overview");
    setBarcodes([]);
  };

  const barCodeHandle = () => {
    const apiUrl = BASE_URL + `/getItemData/${Itemid}`;
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const itemData = data.data;
        setBarCodeName(itemData.name);
        setBarCodeSalesPrice(itemData.salesPrice);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handlePrint = () => {
    const printableContent = document.getElementById("printable-content");
    if (printableContent) {
      const printWindow = window.open();
      printWindow.document.write(`
        <html>
          <head>
            <style>
              @media print {
                .printable-content {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  width: 100%;
                }
                .barcode-container {
                  margin: 12px 0;
                  text-align: left;
                  width: 100%;
                }
                body{
                  font-family: "Nunito", sans-serif;
                  margin:0px;
                  color:black;
                }
              }
            </style>
          </head>
          <body>
            ${printableContent.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.onafterprint = () => {
        printWindow.close();
        printWindow.onafterprint = null;
      };
      printWindow.print();
    }
  };

  // Filter items based on search
  const filteredItems = itemData1.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {showDetails && (
        <div className="item-details-wrapper">
          {/* Header */}
          <div className="item-details-header">
            <div className="d-flex align-items-center">
              <div className="back-button" onClick={handleCancleClick}>
                <ArrowBackIosIcon className="back-icon" />
              </div>
              <div className="header-title">
                <h5 className="page-title">All Items</h5>
                <p className="page-subtitle">{itemData1.length} Items</p>
              </div>
            </div>
          </div>

          {/* Main Container */}
          <div className="item-details-container">
            {/* Left Panel - Item List */}
            <div className="item-list-panel">
              {/* Search Bar */}
              <div className="search-container">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search Items..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* Item List */}
              <div className="item-list">
                {filteredItems.map((item, index) => (
                  <div
                    key={index}
                    className={`item-card ${itemId1 === item.id ? 'active' : ''}`}
                    onClick={() => {
                      handleItemChange(item.id);
                      setSelectedTab("overview");
                      setQuantity("");
                    }}
                  >
                    <div className="item-name">{item.name}</div>
                    <div className="item-meta">
                      <span className="item-type">{item.type}</span>
                      <span className="item-unit">{item.unit}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Panel - Item Details */}
            <div className="item-details-panel">
              {/* Item Header */}
              <div className="item-header">
                <div className="item-title-section">
                  <h2 className="item-title">{itemData.name}</h2>
                  <p className="item-sku">SKU: {itemData.sku || itemData.id}</p>
                </div>
                <button 
                  className="edit-button"
                  onClick={() => handleEditOpen(itemData.id)}
                >
                  <CiEdit size={18} />
                  <span>Edit Item</span>
                </button>
              </div>

              {/* Tabs */}
              <div className="tabs-container">
                <button
                  className={`tab-button ${selectedTab === "overview" ? "active" : ""}`}
                  onClick={() => handleTabClick("overview")}
                >
                  Overview
                </button>
                <button
                  className={`tab-button ${selectedTab === "comments" ? "active" : ""}`}
                  onClick={() => handleTabClick("comments")}
                >
                  Barcode
                </button>
              </div>

              {/* Tab Content */}
              <div className="tab-content">
                {selectedTab === "overview" && (
                  <div className="overview-content">
                    {/* Row 1 */}
                    <div className="cards-row">
                      {/* Item Overview Card */}
                      <div className="info-card">
                        <div className="card-header">
                          <FiBox className="card-icon" />
                          <h3 className="card-title">Item Overview</h3>
                        </div>
                        <div className="card-body">
                          <div className="info-row">
                            <span className="info-label">Item Type</span>
                            <span className="info-value">
                              {itemData.type || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Unit</span>
                            <span className="info-value">
                              {itemData.unit || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Tax Preference</span>
                            <span className="info-value">
                              {itemData.taxPreference || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Reason</span>
                            <span className="info-value">
                              {itemData.exemptionReason || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Inventory Information Card */}
                      <div className="info-card">
                        <div className="card-header">
                          <FiPackage className="card-icon" />
                          <h3 className="card-title">Inventory Information</h3>
                        </div>
                        <div className="card-body">
                          <div className="info-row">
                            <span className="info-label">Available Stock</span>
                            <span className="info-value">
                              {itemData.openingStock || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Reorder Point</span>
                            <span className="info-value">
                              {itemData.reorderPoint || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Row 2 */}
                    <div className="cards-row">
                      {/* Sales Information Card */}
                      <div className="info-card">
                        <div className="card-header">
                          <FiDollarSign className="card-icon" />
                          <h3 className="card-title">Sales Information</h3>
                        </div>
                        <div className="card-body">
                          <div className="info-row">
                            <span className="info-label">Sales Price</span>
                            <span className="info-value">
                              {itemData.salesPrice ? `₹ ${itemData.salesPrice}` : <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Sales Account</span>
                            <span className="info-value">
                              {itemData.account || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Sales Description</span>
                            <span className="info-value">
                              {itemData.description || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Purchase Information Card */}
                      <div className="info-card">
                        <div className="card-header">
                          <FiShoppingCart className="card-icon" />
                          <h3 className="card-title">Purchase Information</h3>
                        </div>
                        <div className="card-body">
                          <div className="info-row">
                            <span className="info-label">Cost Price</span>
                            <span className="info-value">
                              {itemData.purchasePrice ? `₹ ${itemData.purchasePrice}` : <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Purchase Amount</span>
                            <span className="info-value">
                              {itemData.accountP || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Cost Description</span>
                            <span className="info-value">
                              {itemData.descriptionP || <span className="empty-value">Not Available</span>}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedTab === "comments" && (
                  <div className="barcode-content">
                    <div className="barcode-form-card">
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label className="form-label">Enter Quantity</label>
                          <input
                            className="form-input"
                            type="text"
                            placeholder="Enter No. Of Barcode You Want"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                          />
                        </div>
                        <div className="button-group">
                          <button
                            type="submit"
                            className="btn-primary"
                            onClick={barCodeHandle}
                          >
                            Generate Barcodes
                          </button>
                          {barcodes.length > 0 && (
                            <button
                              type="button"
                              className="btn-success"
                              onClick={handlePrint}
                            >
                              Print Barcodes
                            </button>
                          )}
                        </div>
                      </form>
                    </div>

                    {/* Barcode Display */}
                    {barcodes.length > 0 && (
                      <div className="barcode-display-card">
                        <div
                          id="printable-content"
                          className="barcode-grid"
                        >
                          {barcodes.map((barcode, index) => (
                            <div
                              className="barcode-item"
                              key={index}
                            >
                              <h4 className="barcode-company">{companyName}</h4>
                              <h6 className="barcode-name">{barCodeName}</h6>
                              <h5 className="barcode-price">
                                <b>Price: </b>₹ {barCodeSalesPrice}
                              </h5>
                              <div className="barcode-wrapper">
                                <Barcode
                                  value={barcode}
                                  height={30}
                                  width={3}
                                  displayValue={false}
                                />
                                <span className="barcode-text">
                                  {barcode}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showEditPage && <ItemUpdate id={editId} handleCancle={handleCancel} />}
    </>
  );
}

export default ItemDetails;
